import React from 'react'
import PropTypes from 'prop-types'

const InputLabel = (props) => {
  const className = props.class || ''
  const text = props.text || ''
  return (
    <label className={className}>{text}</label>
  )
}

InputLabel.propTypes = {
  class: PropTypes.string,
  text: PropTypes.string,
}

export default InputLabel
